<template>
  <div class="signInSheetVue">
     <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone u-cmn-botmargin">

            <div class="c-responsive-fixwidth">

                <!-- Heading Section -->
                <div class="row u-cmn-botmargin">
                    <div class="col-md-9">
                        <p class="u-back"><a @click="backTojobDetails()"><i class="fa fa-chevron-left"></i> Back</a></p>

                    </div>
                    <div class="col-md-3 text-right">
                        <ul class="o-filter-area">

                            <li class="o-search-field">
                                <div class="input-group stylish-input-group" style="visibility: hidden;">
                                    <input type="text" class="form-control" placeholder="Job Search">
                                    <span class="input-group-addon">
                                            <button type="submit">
                                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                    </button>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-12"><h1 class="h1">Job / Events: {{job.title}}</h1></div>
                    <div class="col-md-12"><h1 class="page-disclaimer-header">Only confirmed Calls Are Displayed To Be Printed</h1></div>
                </div>
                <!-- /Heading Section -->

                <div class="row">
                   
                    <div v-if="signInPageBrokenStatus" v-for="(callsByday, key, index) in signInSheetsData.calls" class="col-lg-6 col-md-12 job-signin-table u-cmn-botmargin">
                        <div class="u-bg-color-fff u-cmn-padding c-common-box-shadow c-radius3 u-relative">
                            <a href="#" class="print-icon" @click="printThis($event)">
                                <i class="fa fa-print" aria-hidden="true"></i>
                            </a>
                            <div class="section-to-print">
                                <div class="row job-signin-table--header">
                                   <div class="col-sm-12 o-no-padding o-display-table">
                                        <div class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img v-if="clientLogo != ''" :src="(clientLogo)" />
                                            <img v-if="clientLogo == ''" src="static/assets/images/logo.png" />
                                        </div>
                                        <div class="col-md-8 col-sm-6 text-left o-display-table-cell">
                                            
                                            <ul class="ps2">
                                                <li v-for="job in jobSigninDetails" v-if="job.name != ''">
                                                <strong>{{job.name}}</strong>:
                                                {{(job.value !='empty_row') ? (job.name == 'Dates' ? convertToFormatDate(job.value) : job.value) : ''}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img src="static/assets/images/logo.png">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>

                                    <!-- <div class="col-sm-12 o-no-padding">
                                        <div class="col-sm-12 ps2 u-cmn-botmargin">
                                            <strong>Comments</strong>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        </div>
                                    </div> -->

                                    <div class="col-sm-12 o-no-padding">
                                        <div class="col-sm-9 ps1 u-cmn-botmargin">
                                            <strong>Day {{index+1}} - {{getDate(key)}}</strong>
                                        </div>
                                        <div class="col-sm-3 ps1 u-cmn-botmargin sign-sortby">
                                            <div class="form-group-right o-custom-dropdown">
                                                <select @change="sortSignInSheet(index)" v-model="selectedSortTypeByDay[index].sortType" class="form-control">
                                                    <option value="-1">Sort by</option>
                                                     <option v-for="(callHeader, index) in getSignInSheetConfig['call-data-config']" :value="index" v-if="callHeader.name !='Signature' && callHeader.name !=''">{{callHeader.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow o-custom-drop-arrow-top"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                            </div>

                            <div class="table-responsive job-signin ps2 u-cmn-botmargin sign-in-sheet-overflow-y">
                                <table class="table table-striped o-signin-sheet-table">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th v-for="callHeader in getSignInSheetConfig['call-data-config']" v-if="callHeader.name != ''">{{callHeader.name}}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(call, indexs) in Object.values(callsByday)">
                                        <td>{{parseInt(indexs) + 1}}</td>
                                        <td v-for="a in call" :style="a.value=='underline'?'padding-top: 21px; padding-bottom: 0px;':''">{{getFieldValue(a.value)}}</td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>


                            <!-- <div class="row text-center">
                                <div class="col-md-12 o-signin-logo">
                                    <img src="static/assets/images/callsteward-old-img.png">
                                </div>
                            </div> -->

                            </div>

                        </div>
                    </div>
                    
                   <div v-if="signInSheetsData.length == 0 ? true : signInSheetsData.calls.length == 0" class="c-common-space c-common-gradient c-common-box-shadow c-radius3 side-padding">
                        <div class="col-md-12 no-job-dispaly">
                           <i class="fa fa-frown-o" aria-hidden="true"></i>
                           <br />
                            No Calls Added
                        </div>
                    </div>

                    <div v-if="!signInPageBrokenStatus" class="col-lg-6 col-md-12 job-signin-table u-cmn-botmargin">
                        <div class="u-bg-color-fff u-cmn-padding c-common-box-shadow c-radius3 u-relative">
                            <a href="#" class="print-icon" @click="printThis($event)">
                                <i class="fa fa-print" aria-hidden="true"></i>
                            </a>
                            <div class="section-to-print">
                                
                                <div class="row job-signin-table--header">
                                    <div class="col-sm-12 o-no-padding o-display-table">
                                        <div class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img v-if="clientLogo != ''" :src="(clientLogo)" />
                                            <img v-if="clientLogo == ''" src="static/assets/images/logo.png" />
                                        </div>
                                        <div class="col-md-8 col-sm-6 text-left o-display-table-cell">
                                            <ul class="ps2">
                                                <li v-for="job in jobSigninDetails"><strong>{{job.name}}</strong>{{(job.value !='empty_row')?job.value : ''}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img src="static/assets/images/logo.png">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>

                                    <!-- <div class="col-sm-12 o-no-padding">
                                        <div class="col-sm-12 ps2 u-cmn-botmargin">
                                            <strong>Comments</strong>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        </div>
                                    </div>   -->

                                </div>
                                <div v-if="!signInPageBrokenStatus" v-for="(callsByday, key, index) in signInSheetsData.calls">
                                    <div class="row job-signin-table--header">
                                        <div class="col-sm-12 o-no-padding">
                                            <div class="col-sm-10 ps1 u-cmn-botmargin">
                                                <strong>Day {{index+1}} - {{getDate(key)}}</strong>
                                            </div>
                                            <div class="col-sm-2 ps1 u-cmn-botmargin sign-sortby">
                                                <div class="form-group-right o-custom-dropdown">
                                                    <select v-model="selectedSortTypeByDay[index].sortType" class="form-control">
                                                        <option value="-1">Sort by</option>
                                                        <option v-for="(callHeader, index) in getSignInSheetConfig['call-data-config']" :value="index">{{callHeader.name}}</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>   
                                    </div>
                                    <div class="table-responsive job-signin ps2 u-cmn-botmargin sign-in-sheet-overflow-y">
                                        <table class="table table-striped o-signin-sheet-table">
                                            <thead>
                                              <tr>
                                                <th>#</th>
                                                <th v-for="callHeader in getSignInSheetConfig['call-data-config']">{{callHeader.name}}</th>
                                               
                                              </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="call in callsByday">
                                                <td>1</td>
                                                <td v-for="a in call" :style="a.value=='underline'?'padding-top: 21px; padding-bottom: 0px;':''">{{getFieldValue(a.value)}}</td>

                                               
                                              </tr>
                                              
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                               <!--  <div class="row text-center">
                                    <div class="col-md-12 o-signin-logo">
                                        <img src="static/assets/images/callsteward-old-img.png">
                                    </div>
                                </div> -->

                            </div>

                        </div>
                    </div>  

                </div>

            </div>
            <!-- c-responsive-fixwidth -->
        </div>
        <!-- /Main Body Content area -->
  </div>
</template>

<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                signInSheetsData: [],
                jobSigninDetails: [],
                callSigninDetails: [],
                selectedSortTypeByDay: [],
                job: [],
                getBaseURL: '',
                clientLogo: ''
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                jobID: 'selectedJobId',
                getSignInSheetConfig: 'getSignInSheetConfig',
                signInPageBrokenStatus: 'signInPageBrokenStatus',
            })
        },
        mounted() {

        },
        methods: {
            sortSignInSheet(index) {
                let curOpt = this.selectedSortTypeByDay[index].sortType;
                let curPos = Object.keys(this.signInSheetsData.calls)[index];
                let curObj = Object.values(this.signInSheetsData.calls[curPos]);

                if (curObj.length > 1) {
                    this.signInSheetsData.calls[curPos] = curObj.sort(function(a, b) {
                        if (a[curOpt].value < b[curOpt].value) return -1;
                        if (a[curOpt].value > b[curOpt].value) return 1;
                        return 0;
                    });
                }
            },
            getFieldValue(value) {
                return (value != 'empty') ? (moment(value, "YYYY-MM-DD HH:mm:ss", true).isValid() ? this.getTime(value) : (value=='underline'?'_____________________':value)) : '';
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            getDate(dateTime) {
                //return dateTimeConvert.globalDate(dateTime);
                //var date = dateTimeConvert.extractDateOnly(dateTime);
                return dateTimeConvert.localDateFull(dateTime);
            },
            convertToFormatDate(dateTime) {
                var dates = dateTime.split('@#@');
                return this.getDate(dates[0]) + ' to ' + this.getDate(dates[1]);
                // return this.getDate(dates[0]) + ' @ ' + this.getTime(dates[0]) + ' to ' + this.getDate(dates[1]) + ' @ ' + this.getTime(dates[1]);
            },
            backTojobDetails() {
                // this.$router.push({
                //     path: `/jobDetails`
                // });
                this.$router.push({
                    path: `/jobDetails/` + this.$route.params.jobId
                });
            },
            getSignInData() {
                this.$Progress.start();
                service.get('call/signInSheets', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'job-id': atob(this.$route.params.jobId)
                }).
                then((res) => {
                    //console.log(res);
                    this.signInSheetsData = res.data.result;
                    this.$Progress.finish();
                    //console.log("API Data", this.signInSheetsData);
                    this.jobSigninDetails = this.signInSheetsData.job;
                    for (let key in this.signInSheetsData.calls) {
                        let tempData = {
                            'sortType': '-1',
                            'date': key,
                        };
                        //console.log(tempData);
                        this.selectedSortTypeByDay.push(tempData);
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            printThis(e) {
                e.preventDefault();
                $('.job-signin-table').hide();
                $(e.target).parents('.job-signin-table').show();
                window.print();
            },
            jobDetails() {
                this.$Progress.start();
                service.get('job/' + atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    //console.log("Job details", res);
                    this.job = res.data.result;

                }).catch((err) => {
                    console.log(err);
                });
            },
        },
        beforeMount() {
            window.onafterprint = function() {
                $('.job-signin-table').show();
            };
            this.getSignInData();
        },
        created() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.jobDetails();
            service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
            }).
            then((res) => {
                this.clientLogo = res.data.result.logo;
                // console.log("res", res.data.result);
                //console.log("Base URL", this.getBaseURL);
                //console.log("Job details", this.clientLogo);
                this.$store.dispatch('setClientdata', res.data.result);

            }).catch((err) => {
                console.log(err);
            });

            // console.log("config Data", atob(this.$route.params.jobId));
        }
    }

</script>
<style scoped>

.page-disclaimer-header {
    font-weight: 500;
    text-align: -webkit-center;
    padding-bottom: 8px;
}
.job-signin { height: auto; }
</style>
